import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Link2Icon from '@mui/icons-material/Link';
import { useDispatch } from 'react-redux';
import { TrackerDataType } from '../../shared/constants/constants';
import {
  adderHeaderTitleSx,
  queryAdderPopupFieldLabelSx,
  queryAdderPopupFormSpacing,
  queryAdderPopupInputSx,
  utilityCancelButtonSx,
  utilityModalContentSx,
  utilityModalDialogSx,
  utilityModalFooterSx,
  utilityModalHeaderSx,
  utilityModalIconTileSx,
  utilityModalPaperSx,
  utilityPrimaryActionButtonSx,
} from '../QueryAdder/queryAdderPopupStyles';

export default function UrlDialog(props) {
  const { id, isOpen, setIsOpen, callback, type, colName, handleSubmit } = props;
  const dispatch = useDispatch();
  const isStoryLink = type === TrackerDataType.MEDIA_INTERACTION;
  const title = isStoryLink ? 'Add Story' : 'Add Link to File';
  const urlLabel = isStoryLink ? 'URL' : 'Link to File';
  const nameLabel = isStoryLink ? 'Title' : 'File Name';
  const modalFieldLabelSx = {
    ...queryAdderPopupFieldLabelSx,
    fontWeight: 500,
  };

  const [dialogValue, setDialogValue] = React.useState({
    url: '',
    name: '',
    description: '',
  });

  const handleClose = () => {
    setDialogValue({
      url: '',
      name: '',
      description: '',
    });

    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={utilityModalDialogSx}
      PaperProps={{
        sx: {
          ...utilityModalPaperSx,
        },
      }}
    >
      <form
        onSubmit={(event) => {
          event.stopPropagation();
          return handleSubmit(callback, dialogValue, handleClose, colName, id, dispatch)(event);
        }}
        style={{ display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}
      >
        <DialogTitle sx={utilityModalHeaderSx}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box sx={utilityModalIconTileSx}>
              <Link2Icon sx={{ fontSize: 20 }} />
            </Box>
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  ...adderHeaderTitleSx,
                }}
              >
                {title}
              </Typography>
            </Box>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ ...utilityModalContentSx, pt: '24px !important' }}>
          <Stack spacing={queryAdderPopupFormSpacing}>
            <Box>
              <Typography sx={modalFieldLabelSx}>
                {urlLabel}{' '}
                <Box component="span" sx={{ color: 'primary.main' }}>
                  *
                </Box>
              </Typography>
              <TextField
                required
                autoFocus
                id="url"
                fullWidth
                value={dialogValue.url}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    url: event.target.value,
                  })
                }
                type="text"
                variant="outlined"
                sx={queryAdderPopupInputSx}
              />
            </Box>
            <Box>
              <Typography sx={modalFieldLabelSx}>
                {nameLabel}{' '}
                <Box component="span" sx={{ color: 'primary.main' }}>
                  *
                </Box>
              </Typography>
              <TextField
                required
                id="name"
                fullWidth
                value={dialogValue.name}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    name: event.target.value,
                  })
                }
                type="text"
                variant="outlined"
                sx={queryAdderPopupInputSx}
              />
            </Box>
            <Box>
              <Typography sx={modalFieldLabelSx}>Description</Typography>
              <TextField
                id="description"
                fullWidth
                multiline
                minRows={3}
                value={dialogValue.description}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    description: event.target.value,
                  })
                }
                type="text"
                variant="outlined"
                sx={queryAdderPopupInputSx}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ ...utilityModalFooterSx, justifyContent: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            <Button
              onClick={handleClose}
              startIcon={<CloseIcon />}
              variant="outlined"
              sx={{
                ...utilityCancelButtonSx,
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-cy="Url-button-submit"
              startIcon={<AddIcon />}
              variant="contained"
              sx={utilityPrimaryActionButtonSx}
            >
              Add
            </Button>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  );
}
